/**
 * E-007 chrome. L-044 mounts it on /authoring (authoring MFE). Other
 * staff tools stay tokens-only (L-035 S-008). Paths are tutor-mfe URL
 * prefixes (Verawood).
 */
const STAFF_TOKEN_ONLY_PREFIXES = [
  "/instructor-dashboard",
  "/gradebook",
  "/ora-grading",
  "/admin-console",
  "/communications",
];

export function isStudioPath(pathname) {
  const path = pathname || "";
  return STAFF_TOKEN_ONLY_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

/** Authoring leftover MFE (apps…/authoring/…). L-044 / L-045. */
export function isAuthoringPath(pathname) {
  const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "");
  return path === "/authoring" || path.startsWith("/authoring/");
}

export function isLearnerChrome(pathname) {
  if (typeof window === "undefined" && !pathname) return true;
  return !isStudioPath(pathname || window.location.pathname);
}